import {createReducer, on} from '@ngrx/store';
import {
  kliknietoDalejRoszczenieSuccess
} from '../../../../samoobsluga/proces-decyzji/ekran-pytanie-o-roszczenie/store/ekran-roszczenie.actions';
import {parametryKwotyDocelowejStanPoczatkowy} from './parametryKwotyDocelowej.stan-poczatkowy';
import {ParametryKwotyDocelowej} from '../../../services/samoobsluga/types/ParametryKwotyDocelowej.interface';
import {wyczyscParametryKwotyDocelowej} from './parametryKwotyDocelowej.actions';

export const parametryKwotyDocelowejReducer = createReducer(
  parametryKwotyDocelowejStanPoczatkowy,
  on(kliknietoDalejRoszczenieSuccess,
    (state, action): ParametryKwotyDocelowej => {
      return ({
        ...state,
        kwotaDocelowa: action.kwotaDocelowa,
        limitKomeptencyjny: action.limitKomeptencyjny
      })
    }),
  on(wyczyscParametryKwotyDocelowej,
    (state): ParametryKwotyDocelowej => {
      return ({
        ...state,
        kwotaDocelowa: null,
        limitKomeptencyjny: null
      })
    }),
)
